const StatPill = ({ value, label }) => {
  return (
    <div className="rounded-xl border border-slate-200 bg-white/80 px-4 py-3 backdrop-blur-sm">
      <p className="text-2xl font-semibold tracking-tight text-slate-900">{value}</p>
      <p className="text-xs font-medium uppercase tracking-wider text-slate-500">{label}</p>
    </div>
  );
};

export default StatPill;
